import React from 'react'

import MenuSection from '../MenuSection'
import UserSearch from '../UserSearch'

import { WATCHER_OPTIONS, TASKS_FOR_WATCHER } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

type WatcherFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const WatcherFilter: React.FC<WatcherFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()
  const { user } = useEnvironment()

  return (
    <MenuSection
      title='Watchers'
      options={WATCHER_OPTIONS}
      value={state.watcherValue}
      setValue={handleChange('watcherValue')}
      unassignedOpt='All Watchers'
      {...props}
    >
      {state.watcherValue === TASKS_FOR_WATCHER && (
        <UserSearch
          userID={user?.id}
          value={state.watcherID}
          setValue={handleChange('watcherID')}
          startOpen
        />
      )}
    </MenuSection>
  )
}

export default WatcherFilter
